import React from 'react';

export default function ManufacturingFacilitiesTable() {
  return (
    <section className="pt-4 pb-[11px] md:pb-[100px] bg-[#F9F9F9]">
      <div className="container-custom">
        <div className="overflow-x-auto">
          {/* Use border-separate + border-spacing-0 to avoid inner vertical lines and keep rounded corners */}
          <table className="w-full border-separate border-spacing-0 border border-black shadow-sm mb-0 md:mb-[30px]">
            <tbody>
              {/* Heading */}
              <tr>
                <td colSpan={2} className="p-6 border-black">
                  <h2 className="text-[28px] font-bold leading-[130%] tracking-[-0.03em] text-gray-900 roboto-font-bold">
                    Agastya Agro Limited – Overview of Key Manufacturing Facilities
                  </h2>
                </td>
              </tr>

              {/* Facility Name */}
              <tr>
                <td className="px-4 md:px-6 py-4 roboto-font-medium w-1/4 border-t border-black">
                  Facility Name
                </td>
                <td className="px-4 md:px-6 py-4 roboto-font-normal border-t border-black">
                  State-of-the-Art Manufacturing Facility in Ahmedabad
                </td>
              </tr>

              {/* Location */}
              <tr>
                <td className="px-4 md:px-6 py-4 roboto-font-medium w-1/4 border-t border-black">
                  Location
                </td>
                <td className="px-4 md:px-6 py-4 roboto-font-normal border-t border-black">
                  Ahmedabad, Gujarat (Industrial Hub)
                </td>
              </tr>

              {/* Company */}
              <tr>
                <td className="px-4 md:px-6 py-4 roboto-font-medium w-1/4 border-t border-black">
                  Company
                </td>
                <td className="px-4 md:px-6 py-4 roboto-font-normal border-t border-black">
                  Agastya Agro Limited
                </td>
              </tr>

              {/* Key Features */}
              <tr>
                <td className="px-4 md:px-6 py-4 roboto-font-medium w-1/4 border-t border-black">
                  Key Features
                </td>
                <td className="px-4 md:px-6 py-4 roboto-font-normal border-t border-black">
                  <div className="space-y-1">
                    <div>- Cutting-edge equipment</div>
                    <div>- Strict quality protocols</div>
                    <div>- Built for efficiency, scalability, and compliance</div>
                  </div>
                </td>
              </tr>

              {/* Products Manufactured */}
              <tr>
                <td className="px-4 md:px-6 py-4 roboto-font-medium w-1/4 border-t border-black">
                  Products Manufactured
                </td>
                <td className="px-4 md:px-6 py-4 roboto-font-normal border-t border-black">
                  <div className="space-y-1">
                    <div>- Fungicides</div>
                    <div>- Insecticides</div>
                    <div>- Herbicides</div>
                  </div>
                </td>
              </tr>

              {/* Purpose / Role */}
              <tr>
                <td className="px-4 md:px-6 py-4 roboto-font-medium w-1/4 border-t border-black">
                  Purpose / Role
                </td>
                <td className="px-6 py-4 roboto-font-normal border-t border-black">
                  Core production unit supporting national demand for agrochemical solutions
                </td>
              </tr>

              {/* Impact */}
              <tr>
                <td className="px-6 py-4 roboto-font-medium w-1/4 border-t border-black">
                  Impact
                </td>
                <td className="px-4 md:px-6 py-4 roboto-font-normal border-t border-black">
                  Enables consistent supply of high-quality crop protection products across India
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
